import { createInstance } from '@optimizely/optimizely-sdk';

class OptimizelyClientService {
    optimizely;
    initialize(clientId) {
        this.optimizely = createInstance({
            sdkKey: clientId,
        });
    }
    // Ensure the client is initialized
    async ensureClientReady() {
        if (this.optimizely === null) {
            return;
        }
        await this.optimizely.onReady();
    }
    // Method to check if a feature is enabled
    async isFeatureEnabled(featureKey, attributes) {
        try {
            await this.ensureClientReady();
            return ((this.optimizely !== null &&
                this.optimizely.isFeatureEnabled(featureKey, '', attributes)) ||
                false);
        }
        catch (error) {
            console.error('Error checking feature flag:', error);
            return false; // Return false in case of error
        }
    }
}

export { OptimizelyClientService as default };
//# sourceMappingURL=optimizelyClientService.js.map
